import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import CustomReportEmployeeSearch from "./CustomReportEmployeeSearch"
import CustomReportSelectedEmployees from "./CustomReportSelectedEmployees"
import PersonCardShape from "../../../../state/shapes/PersonCardShape"

const CustomReportEmployeeSelection = ({
  theme,
  onSearchChange,
  searchResults,
  onEmployeeSelection,
  employeeRemoved,
  selectedEmployees,
  includeDirectReportsChangeHandler,
  t,
}) => {
  return (
    <Fragment>
      <p>
        <em>{t("CustomReport.LocationsEmployeeSelection.EmployeeSearchIntro")}</em>
      </p>
      <div className="row">
        <div className="col-md-6">
          <CustomReportEmployeeSearch
            onChange={onSearchChange}
            theme={theme}
            searchResults={searchResults}
          />
        </div>
        <div className="col-md-6">
          <CustomReportSelectedEmployees
            onEmployeeSelection={onEmployeeSelection}
            employeeRemoved={employeeRemoved}
            selectedEmployees={selectedEmployees}
            includeDirectReportsChangeHandler={includeDirectReportsChangeHandler}
          />
        </div>
      </div>
    </Fragment>
  )
}

CustomReportEmployeeSelection.propTypes = {
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
  searchResults: PropTypes.arrayOf(PropTypes.shape(PersonCardShape)),
  onSearchChange: PropTypes.func.isRequired,
  onEmployeeSelection: PropTypes.func.isRequired,
  employeeRemoved: PropTypes.func.isRequired,
  selectedEmployees: PropTypes.arrayOf(PropTypes.shape(PersonCardShape)),
  includeDirectReportsChangeHandler: PropTypes.func.isRequired,
}

CustomReportEmployeeSelection.defaultProps = {
  searchResults: null,
  selectedEmployees: null,
}

export default translate()(CustomReportEmployeeSelection)



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/LocationsEmployeesSelection/CustomReportEmployeeSelection.jsx